// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"edb49d7a","703":"44a3b2a1","787":"e0a67ab0"}[chunkId] + ".chunk.js";
};